import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import Config from 'app/Config';
import continueButton from '../images/continuebutton.svg';
import continueButtonHover from '../images/continue-button-hover.svg';
import continueButtonActive from '../images/continue-button-pressed.svg';
import './VasimCard.scss';

const VasimCard = ({ card, context }) => {
    const [isHover, setIsHover] = useState(false);
    const [isActive, setIsActive] = useState(false);

    // Extract card data
    const mediaRef = card.media;
    const cardHeader = card.cardHeader?.value;
    const cardParagraph = card.cardParagraph?.value;
    const showPriceText = card.showPriceText?.value;
    const cardPriceText = card.cardPriceText?.value;
    const cardButtonLink = card.cardButtonLink?.expandedValue?.url;
    const showTag = card.showTag?.value;
    const tagText = card.tagText?.value;

    // Get media information
    const getMediaInfo = () => {
        if (!mediaRef?.expandedValue) return null;

        const mediaUrl = Config.epiBaseUrl + mediaRef.expandedValue.url;
        const contentType = mediaRef.expandedValue.contentType?.[0] || '';
        const isVideo = contentType.toLowerCase().includes('video') || mediaUrl.toLowerCase().endsWith('.mp4');
        const isGif = mediaUrl.toLowerCase().endsWith('.gif');

        return { url: mediaUrl, isVideo, isGif };
    };

    const mediaInfo = getMediaInfo();

    // Get the appropriate button image based on state
    const getButtonImage = () => {
        if (isActive) return continueButtonActive;
        if (isHover) return continueButtonHover;
        return continueButton;
    };

    // Card content
    const cardContent = (
        <div
            className="vasim-card"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onMouseDown={() => setIsActive(true)}
            onMouseUp={() => setIsActive(false)}
        >
            {showTag && tagText && (
                <div className="card-tag">{tagText}</div>
            )}
            <div className='media-div'>
                {mediaInfo?.url && (
                    mediaInfo.isVideo ? (
                        <video className="card-video" autoPlay loop playsInline muted>
                            <source src={mediaInfo.url} type="video/mp4" />
                        </video>
                    ) : (
                        <Image className="card-image" src={mediaInfo.url} alt={cardHeader || 'Card media'} />
                    )
                )}
            </div>
            <div className="content-div">
                 <div className="text">
                     {cardHeader && (
                         <div className="card-header-vasim">{cardHeader}</div>
                     )}
                     <div className="card-paragraph">
                       {cardParagraph && (
                           <div className="card-paragraph-text-vasim" dangerouslySetInnerHTML={{ __html: cardParagraph }} />
                       )}
                     </div>
                </div>
                 <div className="price-button-div">
                     <div className="price-section">
                         {showPriceText && cardPriceText && (
                             <div className="card-price" dangerouslySetInnerHTML={{ __html: cardPriceText }} style={{ marginBottom: 0 }} />
                         )}
                     </div>
                     {cardButtonLink ? (
                         <a href={cardButtonLink} className="card-button">
                             <Image src={getButtonImage()} alt="Continue" />
                         </a>
                     ) : (
                         <span className="card-button card-button--placeholder" aria-hidden="true">
                             <img src={continueButton} alt="" />
                         </span>
                     )}
                 </div>
            </div>
        </div>
    );

    if (cardButtonLink) {
        return (
            <a href={cardButtonLink} className="vasim-card-link-wrapper">
                {cardContent}
            </a>
        );
    }

    return cardContent;
};

export default VasimCard;

